import { ArrowDownIcon } from "@heroicons/react/20/solid";
import { StoryblokComponent, storyblokEditable } from "@storyblok/react/rsc";
import { addMonths, eachMonthOfInterval } from "date-fns";
import { useState } from "react";

import type {
  CampsiteStoryblok,
  EventOverviewStoryblok,
} from "@/component-types-sb";
import { EventList } from "@/components/layout/EventList";
import { Filter } from "@/components/layout/Filter";
import { BodyText, Divider, H2 } from "@/components/typography";

type EventOverviewProps = {
  blok: EventOverviewStoryblok;
  searchParams: { [key: string]: string | string[] | undefined };
  draft: boolean;
};
const EventOverview = ({ blok }: EventOverviewProps) => {
  const [visibleMonthsCount, setVisibleMonthsCount] = useState(3);
  const [selectedCampsite, setSelectedCampsite] =
    useState<CampsiteStoryblok | null>(null);

  const months = eachMonthOfInterval({
    start: new Date(),
    end: addMonths(new Date(), visibleMonthsCount - 1),
  });
  const maxMonths = 18;

  return (
    <article className="w-full" {...storyblokEditable(blok)}>
      <header>
        {blok.header?.map((nestedBlok) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
      </header>

      <section className="py-8 text-center">
        <H2 as="h1" colorScheme="primary">
          {blok.title}
        </H2>
        <BodyText className="max-w-md mx-auto mt-2 text-center">
          {blok.description}
        </BodyText>

        <Divider />

        <div className="max-w-5xl mx-auto mb-24 grid gap-8 text-left">
          <Filter onSelect={setSelectedCampsite} type="events" />

          <div className="-my-6 overflow-hidden">
            {months.map((date, index) => (
              <EventList
                key={index}
                date={date}
                campsiteId={selectedCampsite?.uuid}
              />
            ))}
          </div>

          {visibleMonthsCount < maxMonths && (
            <button
              className="opacity-50 hover:opacity-100 flex flex-col items-center ml-32"
              onClick={() => {
                setVisibleMonthsCount(
                  Math.min(visibleMonthsCount + 3, maxMonths)
                );
              }}
            >
              weitere Monate anzeigen...
              <ArrowDownIcon className="w-4 h-4" />
            </button>
          )}
        </div>
      </section>
    </article>
  );
};

export default EventOverview;
